module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.c1678b46.ttf";